<template>
    <div>
        <report-header />

        <main id="content" role="main" class="px-md-5" style="padding-top: 8rem;">
            <div class="content container px-5">
                <slot></slot>
            </div>
        </main>
    </div>
</template>

<script>
    import ReportHeader from '@/Layouts/Partials/ReportHeader'

    export default {
        components: {
            ReportHeader
        },
    }
</script>
